<template>
	<div>
		<div class="container">
			<div class="page">
				<div class="d-flex justify-content-center">
					<img :src="banner" class="mb-4" />
				</div>

				<div class="container-fluid">
					<div class="row d-flex justify-content-center">
						<div class="col-lg-10 box">
							<div class="text-center p-2 h5 font-weight-bold">Mulai Bangun Brand</div>

							<form @submit.prevent="submitBrand" novalidate>
								<div class="row">

									<div class="col-md-12 text-right">
										<small class="text-danger">* wajib diisi</small>
									</div>

									<div class="col-md-6">
										<div class="form-group">
											<label>Nama <span class="text-danger">*</span></label>
											<input type="text" class="form-control"
												:class="{ 'is-invalid': errorMessages.name }"
												placeholder="Masukkan Nama Anda..."
												v-model="name" required />
											<small v-if="errorMessages.name" class="invalid-feedback">{{ errorMessages.name }}</small>
										</div>
									</div>

									<div class="col-md-6">
										<div class="form-group">
											<label>Nama Perusahaan / Toko</label>
											<input type="text" class="form-control"
												:class="{ 'is-invalid': errorMessages.storeName }"
												placeholder="Masukkan Nama Perusahaan..." v-model="storeName" />
											<small v-if="errorMessages.storeName" class="invalid-feedback">{{ errorMessages.storeName }}</small>
										</div>
									</div>

									<div class="col-md-6">
										<div class="form-group">
											<label>Email Bisnis <span class="text-danger">*</span></label>
											<input type="email" class="form-control"
												:class="{ 'is-invalid': errorMessages.email }"
												placeholder="Masukkan Email Bisnis Anda..." v-model="email" required />
											<small v-if="errorMessages.email" class="invalid-feedback">{{ errorMessages.email }}</small>
										</div>
									</div>

									<div class="col-md-6">
										<div class="form-group">
											<label>Nomor Telepon / WA <span class="text-danger">*</span></label>
											<div class="input-group">
												<div class="input-group-prepend">
													<span class="input-group-text">{{ countryCode }}</span>
												</div>
												<input type="text" name="phone" class="form-control"
													:class="{ 'is-invalid': errorMessages.phone }"
													placeholder="Masukkan Nomor Telepon Anda..." v-model.trim="phone"
													@input="phoneValidation" minlength="9" required>
												<small v-if="errorMessages.phone" class="invalid-feedback">{{ errorMessages.phone }}</small>
											</div>
										</div>
									</div>

									<div class="col-md-6">
										<div class="form-group">
											<label>Kota <span class="text-danger">*</span></label>
											<multiselect v-model="selectedSubdistrict" :custom-label="cityLabel"
												:show-labels="false" track-by="subdistrict_id"
												@close="subdistrictValidation"
												placeholder="Masukkan Kota / Kecamatan (minimal 3 huruf)"
												:options="subdistricts"
												@search-change="fetchSubdistricts">
											</multiselect>
											<small v-if="errorMessages.subdistrict" class="text-danger">{{ errorMessages.subdistrict }}</small>
										</div>
									</div>

									<div class="col-md-6">
										<div class="form-group">
											<label>Alamat Lengkap <span class="text-danger">*</span></label>
											<textarea class="form-control"
												:class="{ 'is-invalid': errorMessages.address }"
												placeholder="Masukkan Alamat Lengkap..." rows="3"
												required
												v-model="address"></textarea>
											<small v-if="errorMessages.address" class="invalid-feedback">{{ errorMessages.address }}</small>
										</div>
									</div>

									<div class="col-md-6">
										<div class="form-group">
											<label>Jenis Produk Yang Diminati <span class="text-danger">*</span></label>
											<div class="mb-2">
												<multiselect placeholder="Select Category" label="name" track-by="slug"
													@close="categoryValidation" @select="onCategoryChange"
													v-model="selectedCategory" :options="categories" :show-labels="false"
													:allow-empty="false"
													:disabled="categories.length === 0">
												</multiselect>
												<small v-if="errorMessages.category" class="text-danger">{{ errorMessages.category }}</small>
											</div>

											<div>
												<multiselect v-if="subCategories" placeholder="Select Sub Category" label="name" track-by="slug"
													v-model="selectedSubCategory" :options="subCategories" :show-labels="false"
													:allow-empty="false"
													:disabled="subCategories.length === 0">
												</multiselect>
												<small v-if="errorMessages.subCategory" class="text-danger">{{ errorMessages.subCategory }}</small>
											</div>
										</div>
									</div>

									<div class="col-md-6">
										<div class="form-group">
											<label>Deskripsi Produk (Spesifikasi Produk) <span class="text-danger">*</span></label>
											<textarea class="form-control"
												:class="{ 'is-invalid': errorMessages.description }"
												placeholder="Masukkan Deskripsi Produk..." rows="3"
												required
												v-model="description"></textarea>
											<small v-if="errorMessages.description" class="invalid-feedback">{{ errorMessages.description }}</small>
										</div>
									</div>

									<div class="row mx-0 w-100">
										<div class="col-md-4">
											<label>Contoh Foto Produk</label>
											<p class="pc-p">
												Format gambar .jpg .jpeg .png dan ukuran minimum 300 x 300px (Untuk gambar
												optimal gunakan ukuran minimum 700 x 700 px). Ukuran maksimum gambar adalah <b>2MB</b>.
											</p>
											<small v-if="errorMessages.image" class="text-danger">{{ errorMessages.image }}</small>
										</div>
										<div class="col-md-8">
											<div class="box__content">
												<div class="pc-images-list">
													<draggable draggable=".draggable" v-model="product.images"
														v-bind="dragOptions" @start="drag = true" @end="drag = false">
														<transition-group class="row small-gutter" type="transition"
															:name="!drag ? 'flip-list' : null">
															<div class="col" :class="{ draggable: image !== '' }"
																v-for="(image, index) in product.images" :key="index + 0">
																<div v-if="isLoading && image === ''"
																	class="pc-image-empty">
																	<div class="image-loading">
																		<div class="is-loading"></div>
																	</div>
																</div>
																<div v-else-if="image === ''"
																	class="pc-image-empty cursor-pointer"
																	@click="uploadImages(index)">
																	<div class="image-upload-placeholder">
																		<i class="fi fi-rr-picture image-placeholder"></i>
																		<div class="text-placeholder">
																			Foto {{ index + 1 }}
																		</div>
																	</div>
																</div>
																<div v-else class="pc-image" :class="{
																	'is-loading': image === '',
																}">
																	<div class="img"
																		:style="{ backgroundImage: `url('${image}')` }">
																	</div>
																	<i class="material-icons" v-tooltip="'Remove'"
																		@click="removeProductImages(index)">close</i>
																</div>
															</div>
														</transition-group>
													</draggable>
												</div>
												<div class="form-group buttons m-0 hidden">
													<input type="file" accept="image/*" class="input-file"
														ref="imageUploader" id="pc-product-images-file"
														@change="onProductImagesChange" />
												</div>
											</div>
										</div>
									</div>

									<div class="col-md-12">
										<div class="form-group">
											<label>Link Referensi Produk</label>
											<input type="text" class="form-control"
												placeholder="https://"
												v-model.trim="referenceLink">
											<small v-if="errorMessages.referenceLink" class="text-danger">{{ errorMessages.referenceLink }}</small>
										</div>
									</div>

									<div class="col-md-12">
										<div class="form-group">
											<label>Dari mana Anda mengetahui tentang Ostock <span class="text-danger">*</span></label>
											<select v-model="selectedSource" @change="sourceValidation" class="form-control">
												<option value="" disabled selected>Pilih Sumber</option>
												<option :value="source.value" v-for="source in sourceOptions"
													:key="source.value">{{ source.label }}</option>
											</select>
											<small v-if="errorMessages.selectedSource" class="text-danger">{{ errorMessages.selectedSource }}</small>
										</div>
									</div>

									<div class="col-md-12" v-if="isOtherSource">
										<div class="form-group">
											<label>Masukkan Sumber Lainnya <span class="text-danger">*</span></label>
											<input type="text" class="form-control"
												placeholder="Masukkan Sumber Lainnya"
												@keyup="sourceValueValidation"
												v-model.trim="sourceValue">
											<small v-if="errorMessages.sourceValue" class="text-danger">{{ errorMessages.sourceValue }}</small>
										</div>
									</div>

									<div class="col-md-12 d-flex justify-content-center">
										<div class="form-group">
											<recaptcha ref="recaptcha"></recaptcha>
										</div>
									</div>

									<div class="col-md-12">
										<div class="form-group">
											<button type="submit" class="btn btn-primary btn-block"
												:class="{
													'is-loading': isSubmit,
												}">Submit</button>
										</div>
									</div>
								</div>
							</form>
						</div>
					</div>
				</div>

			</div>
		</div>

		<auth-modal v-if="isShowAuthModal" @close="isShowAuthModal = false">
			<div slot="body">
				<login-box v-if="isLoginForm" @toggle="toggleForm" :type="formType"></login-box>
				<register-box v-else @toggle="toggleForm" :type="formType"></register-box>
			</div>
		</auth-modal>

		<main-footer />
	</div>
</template>

<script>
import draggable from 'vuedraggable';
import { mapGetters } from 'vuex';
import { duplicateVar, isUrlValid, getAxiosErrorMessage } from '@/lib/helper';
import shipping from '@/api/shipping';
import homepageApi from '@/api/homepage';
import brandApi from '@/api/brand';
import mediaApi from '@/api/media';
import MainFooter from '@/components/homepages/Footer.vue';
import Recaptcha from '@/components/Recaptcha.vue';
import AuthModal from '@/components/auth/AuthModal.vue';
import LoginBox from '@/components/auth/LoginBox.vue';
import RegisterBox from '@/components/auth/RegisterBox.vue';
import { sourceOptions } from '@/lib/statics';

export default {
	name: 'Brand',
	components: {
		MainFooter,
		Recaptcha,
		AuthModal,
		LoginBox,
		RegisterBox,
		draggable,
	},
	data() {
		return {
			formType: 'brand',
			banner: 'https://cdn.ostock.id/uploads/2023/06/2414191687146157998.png',
			name: '',
			storeName: '',
			email: '',
			countryCode: '+62',
			phone: '',
			isLoadingSubdistrics: false,
			subdistrictKeyword: '',
			subdistricts: [],
			selectedSubdistrict: null,
			address: '',
			isFetchingCategories: false,
			categories: [],
			subCategories: [],
			selectedCategory: null,
			selectedSubCategory: null,
			description: '',
			isLoading: false, // is uploading images
			drag: false,
			dragOptions: {
				animation: 100,
			},
			product: {
				images: ['', '', '', '', ''],
			},
			productImages: [],
			productImagesLimit: 5,
			referenceLink: '',
			sourceOptions,
			selectedSource: '',
			sourceValue: '',
			submitError: null,
			isSubmit: false,
			isShowAuthModal: false,
			isLoginForm: true,
			errorMessages: {
				name: '',
				// storeName: '',
				email: '',
				phone: '',
				subdistrict: '',
				address: '',
				category: '',
				subCategory: '',
				description: '',
				image: '',
				referenceLink: '',
				selectedSource: '',
				sourceValue: '',
			},
		};
	},
	methods: {
		toggleForm(value) {
			this.isLoginForm = value;
		},
		// form validation start
		nameValidation() {
			if (this.name.length <= 0) {
				this.errorMessages.name = 'Nama Wajib Diisi';
			} else {
				this.errorMessages.name = '';
			}
		},
		storeNameValidation() {
			if (this.storeName.length <= 0) {
				this.errorMessages.storeName = 'Nama Perusahaan Wajib Diisi';
			} else {
				this.errorMessages.storeName = '';
			}
		},
		isEmailValid(email) {
			if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
				return true;
			}
			return false;
		},
		emailValidation() {
			if (this.email.length <= 0) {
				this.errorMessages.email = 'Email Wajib Diisi';
			} else if (!this.isEmailValid(this.email)) {
				this.errorMessages.email = 'Email Tidak Valid';
			} else {
				this.errorMessages.email = '';
			}
		},
		isPhoneError() {
			return (
				this.phone.trim() !== ''
				&& !new RegExp(/^\+\d+$/).test(this.phone.trim())
			);
		},
		phoneValidation() {
			const validPhone = this.isPhoneError();
			this.phone = this.phone.replace(/[^\d]/g, '');
			if (validPhone) {
				const firstSelection = this.phone.substring(0, 1);
				const secondSelection = this.phone.substring(0, 2);
				let phone = this.phone;
				if (secondSelection === '62') {
					phone = phone.replace('62', '');
				} else if (firstSelection === '0') {
					phone = phone.replace('0', '');
				}
				this.phone = phone;
				if (this.phone.length < 9) {
					this.errorMessages.phone = 'Nomor Telepon Minimal 9 Digit';
				} else {
					this.errorMessages.phone = '';
				}
			} else {
				this.errorMessages.phone = 'Nomor Telepon Tidak Valid';
			}
		},
		subdistrictValidation() {
			if (this.selectedSubdistrict) {
				this.errorMessages.subdistrict = '';
			} else {
				this.errorMessages.subdistrict = 'Kota Wajib Dipilih';
			}
		},
		addressValidation() {
			if (this.address.length <= 0) {
				this.errorMessages.address = 'Alamat Lengkap Wajib Diisi';
			} else {
				this.errorMessages.address = '';
			}
		},
		categoryValidation() {
			if (this.selectedCategory
				&& this.selectedCategory.slug !== 'uncategorized'
				&& this.selectedCategory.slug !== 'produk-lainnya') {
				this.errorMessages.category = '';
			} else {
				this.errorMessages.category = 'Kategori Wajib Dipilih';
			}
		},
		subCategoryValidation() {
			if (this.selectedSubCategory) {
				this.errorMessages.subCategory = '';
			} else {
				this.errorMessages.subCategory = 'Sub Kategori Wajib Dipilih';
			}
		},
		descriptionValidation() {
			if (this.description.length <= 0) {
				this.errorMessages.description = 'Deskripsi Wajib Diisi';
			} else {
				this.errorMessages.description = '';
			}
		},
		linkImageValidation() {
			const image = this.product.images.find(img => img !== '');
			if (!image && !this.referenceLink) {
				this.errorMessages.image = 'Upload minimal 1 gambar atau isi Link Referensi';
				this.errorMessages.referenceLink = 'Isi Link Referensi atau Upload minimal 1 gambar';
			} else if (this.referenceLink && !isUrlValid(this.referenceLink)) {
				this.errorMessages.referenceLink = 'Link harus valid dan diawali https:// atau http://';
			} else {
				this.errorMessages.image = '';
				this.errorMessages.referenceLink = '';
			}
		},
		sourceValidation() {
			if (this.selectedSource === '') {
				this.errorMessages.selectedSource = 'Source Wajib Dipilih';
			} else {
				this.errorMessages.selectedSource = '';
			}
		},
		sourceValueValidation() {
			if (this.selectedSource === 'others' && this.sourceValue === '') {
				this.errorMessages.sourceValue = 'Source Wajib Diisi';
			} else {
				this.errorMessages.sourceValue = '';
			}
		},
		validateAllForm() {
			this.nameValidation();
			// this.storeNameValidation();
			this.emailValidation();
			this.phoneValidation();
			this.subdistrictValidation();
			this.addressValidation();
			this.categoryValidation();
			// this.subCategoryValidation();
			this.descriptionValidation();
			this.linkImageValidation();
			this.sourceValidation();
			this.sourceValueValidation();
		},
		// form validation end
		getSubdistricts() {
			this.isLoadingSubdistrics = true;
			const subdistrictIds = JSON.stringify(this.originIds);
			const params = {
				page: 1,
				subdistrict_ids: subdistrictIds,
				get_complete_data: true,
				keyword: this.subdistrictKeyword,
			};
			const callback = (response) => {
				const subdistricts = response.data;
				this.subdistricts = subdistricts;
				this.isLoadingSubdistrics = false;
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Get Subdistricts',
					text: message,
				});
				this.isLoadingSubdistrics = false;
			};
			shipping.getCompleteSubdistricts(params, callback, errorCallback);
		},
		fetchSubdistricts(query) {
			if (query.length >= 3) {
				this.subdistrictKeyword = query;
				this.getSubdistricts();
			}
		},
		// eslint-disable-next-line camelcase
		cityLabel({ province_name, city_name_with_type, subdistrict_name }) {
			// eslint-disable-next-line camelcase
			return `${province_name}, ${city_name_with_type}, ${subdistrict_name}`;
		},
		fetchCategories() {
			this.isFetchingCategories = true;
			const callback = (response) => {
				this.isFetchingCategories = false;
				const categories = response.data;
				this.categories = categories;
			};
			const errorCallback = () => {
				this.isFetchingCategories = false;
			};
			homepageApi.getAllCategories(callback, errorCallback);
		},
		onCategoryChange(category) {
			this.selectedSubCategory = null;
			this.subCategories = category?.sub_categories;
		},
		uploadImages(index) {
			this.currentIndexUploadImage = index;
			const inputFile = this.$refs.imageUploader;
			inputFile.click();
		},
		onProductImagesChange(event) {
			this.isLoading = true;
			const maxUploadSize = 2; // MB
			const input = event.target;
			for (let i = 0; i < input.files.length; i++) {
				const image = input.files[i];

				// Check File Size
				let fileSize = image.size;
				fileSize /= 1048576;

				// Limit Images
				const isLimitReached =
					this.productImages.length === this.productImagesLimit;
				const isFileSizeTooLarge = fileSize > maxUploadSize;

				// Show Notice if size too large
				if (isFileSizeTooLarge) {
					const noticeMessage = `'${image.name}' size is too large (max 2MB)`;
					this.$notify({
						group: 'app',
						text: noticeMessage,
						type: 'warn',
					});
					this.isLoading = false;
					break;
				}

				if (isLimitReached) {
					const noticeMessage = 'Maksimum upload 5 foto produk';
					this.$notify({
						group: 'app',
						text: noticeMessage,
						type: 'warn',
					});
					this.isLoading = false;
					break;
				}

				this.productImages.push(image);

				const previewIndex = this.currentIndexUploadImage;

				this.$set(this.product.images, previewIndex, '');

				// Load the image file into a canvas element
				const img = new Image();
				const canvas = document.createElement('canvas');
				const ctx = canvas.getContext('2d');
				const reader = new FileReader();
				// eslint-disable-next-line no-loop-func
				reader.onload = () => {
					img.onload = () => {
						const size = Math.max(img.width, img.height);
						canvas.width = size;
						canvas.height = size;
						const offsetX = (size - img.width) / 2;
						const offsetY = (size - img.height) / 2;
						ctx.fillStyle = '#fff';
						ctx.fillRect(0, 0, size, size); // fill the canvas with white
						ctx.drawImage(img, offsetX, offsetY);

						// Convert the canvas to a blob and upload it to the server
						canvas.toBlob((blob) => {
							// Start Upload
							const uploadParams = new FormData();
							uploadParams.append('image', blob);

							const callback = (response) => {
								this.isLoading = false;
								const path = response.data;
								const url = `${this.mediaUrlPrefix}/${path}`;
								this.$set(this.product.images, previewIndex, url);
								this.linkImageValidation();
							};

							const errorCallback = () => {
								this.isLoading = false;
								// eslint-disable-next-line
								this.productImages.splice(previewIndex, 1);
								this.product.images.splice(previewIndex, 1);
								this.linkImageValidation();
							};

							// Upload Image
							mediaApi.uploadImagePublic(uploadParams, callback, errorCallback);
						}, image.type, 0.9);
					};
					img.src = reader.result;
				};
				reader.readAsDataURL(image);
			}
			event.target.files = null;
			event.target.value = '';
		},
		removeProductImages(index) {
			this.productImages.splice(index, 1);
			this.product.images.splice(index, 1, '');
		},
		getAddressParams() {
			const customerAddress = {
				address: this.address,
				city: this.selectedSubdistrict.city,
				city_id: this.selectedSubdistrict.city_id,
				city_name: this.selectedSubdistrict.city_name,
				city_name_with_type: this.selectedSubdistrict.city_name_with_type,
				district_id: this.selectedSubdistrict.district_id,
				province_id: this.selectedSubdistrict.province_id,
				province_name: this.selectedSubdistrict.province_name,
				subdistrict_id: this.selectedSubdistrict.subdistrict_id,
				subdistrict_name: this.selectedSubdistrict.subdistrict_name,
				zip: this.selectedSubdistrict.zip,
			};

			return customerAddress;
		},
		getCategoryParams() {
			const selectedSubCategory = duplicateVar(this.selectedSubCategory);
			const selectedCategory = duplicateVar(this.selectedCategory);
			delete selectedSubCategory.sub_sub_categories;
			delete selectedCategory.sub_categories;
			delete selectedCategory._id;
			delete selectedSubCategory._id;
			delete selectedSubCategory.parent_id;

			const category = {
				...selectedCategory,
				sub_category: selectedSubCategory,
			};

			return category;
		},
		getSourceParams() {
			const source = {
				key: this.selectedSource,
				value: this.isOtherSource ? this.sourceValue : this.selectedSource,
			};

			return source;
		},
		storeBrand() {
			this.isSubmit = true;

			const customerAddress = this.getAddressParams();
			const category = this.getCategoryParams();
			const source = this.getSourceParams();

			const params = {
				name: this.name,
				store_name: this.storeName,
				phone: `${this.countryCode}${this.phone}`,
				email: this.email,
				customer_address: customerAddress,
				category,
				description: this.description,
				product_images: this.product.images,
				reference_link: this.referenceLink,
				source,
			};

			if (!this.user) {
				localStorage.setItem('brandData', JSON.stringify(params));
				this.isShowAuthModal = true;
				this.isSubmit = false;
				return;
			}

			const userId = (this.user.role !== 'owner') ? this.user.parent_id : this.user._id;
			params.user_id = userId;

			const callback = (response) => {
				const message = response.message;
				this.$notify({
					group: 'app',
					title: 'Save Brand',
					text: message,
					type: 'success',
				});
				this.isSubmit = false;
				this.$router.push('/brand/list');
			};

			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					title: 'Save Brand',
					text: message,
					type: 'error',
				});
				this.isSubmit = false;
			};

			brandApi.createBrand(params, callback, errorCallback);
		},
		submitBrand() {
			this.validateAllForm();
			const isErrorExist = Object.values(this.errorMessages).find(val => val !== '');
			if (isErrorExist) {
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Failed',
					text: 'Form harus diisi.',
				});
				return;
			}

			const gRecaptchaResponse = document.getElementsByName('g-recaptcha-response')[0]?.value ?? '';

			if (gRecaptchaResponse === '') {
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Failed',
					text: 'Recaptcha harus diisi.',
				});
			} else {
				this.storeBrand();
			}
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
		}),
		isOtherSource() {
			return this.selectedSource === 'others';
		},
	},
	watch: {
		name() {
			this.nameValidation();
		},
		// storeName() {
		// 	this.storeNameValidation();
		// },
		email() {
			this.emailValidation();
		},
		address() {
			this.addressValidation();
		},
		description() {
			this.descriptionValidation();
		},
		referenceLink() {
			this.linkImageValidation();
		},
		submitError() {
			if (typeof window.grecaptcha !== 'undefined') {
				window.grecaptcha.reset();
			}
		},
	},
	created() {
		this.fetchCategories();
	},
};
</script>
